import { render } from "./FormRangeSlider.vue?vue&type=template&id=45a9e4b1"
import script from "./FormRangeSlider.vue?vue&type=script&lang=js"
export * from "./FormRangeSlider.vue?vue&type=script&lang=js"
script.render = render

export default script